var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetInstructions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0417 6.33333H18.9583M17.5 25.2917V25.3063M8.75 7.79167C8.75 7.01812 9.05729 6.27625 9.60427 5.72927C10.1513 5.18229 10.8931 4.875 11.6667 4.875H23.3333C24.1069 4.875 24.8487 5.18229 25.3957 5.72927C25.9427 6.27625 26.25 7.01812 26.25 7.79167V28.2083C26.25 28.9819 25.9427 29.7237 25.3957 30.2707C24.8487 30.8177 24.1069 31.125 23.3333 31.125H11.6667C10.8931 31.125 10.1513 30.8177 9.60427 30.2707C9.05729 29.7237 8.75 28.9819 8.75 28.2083V7.79167Z",
    stroke: "white",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetInstructions);
export default __webpack_public_path__ + "static/media/getInstructions.7a9220729eb0d42d220af200b037fa79.svg";
export { ForwardRef as ReactComponent };